import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { AlertMessageService } from "./services/alert.message.service";
import { DynamicFormDefinition } from '@dynamic-forms/core';

@Injectable({
	providedIn: "root",
})
export class Util {

	loading: boolean = false;

	constructor(
		private datePipe: DatePipe,
		private _alert: AlertMessageService,
	) { }
	public convertTo12Hours(date: any) {
		return this.datePipe.transform(date, "hh:mm a");
	}

	public convertTo24Hours(time: string): string {
		// Parse the time string into a date object
		const parsedTime = new Date(`2000-01-01 ${time}`);

		// Check if the parsedTime is valid
		if (!isNaN(parsedTime.getTime())) {
			// If valid, format the date object to 24-hour time using the DatePipe
			return this.datePipe.transform(parsedTime, "HH:mm");
		} else {
			// If not valid, return null or handle the error accordingly
			return null; // or throw an error, log a message, etc.
		}
	}

	public formatDate(date: string, format: string): string {
		return this.datePipe.transform(date, format);
	}

	public showAlert(type: string, message: string, selfClose: boolean = true) {
		// type: 'success',
		// type: 'info',
		// type: 'warning',
		// type: 'danger',
		let alert: any = {
			type: type,
			message: message,
			selfClose: selfClose,
		};
		this._alert.apply(alert);
	}

	getLocalTimeZoneOffset(): string {
		const date = new Date();
		const timezoneOffset = date.getTimezoneOffset(); // Offset in minutes

		// Convert to hours and minutes
		const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
		const offsetMinutes = Math.abs(timezoneOffset) % 60;
		const sign = timezoneOffset > 0 ? '-' : '+';

		// Format the offset (e.g., "+05:30")
		const formattedOffset = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;

		console.log('Timezone Offset (minutes):', timezoneOffset);
		console.log('Formatted Timezone Offset:', formattedOffset);
		const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		return formattedOffset
	}

 	createDynamicFormDefinition: (json) => DynamicFormDefinition = (json) => JSON.parse(JSON.stringify(json));

	 toTitleCase(str) {
		if (!str) return ""; // Handle empty or undefined input
		return str
			.split('_') // Split the string by underscores
			.map(word => word.length > 0 ? word[0].toUpperCase() + word.slice(1).toLowerCase() : "") // Capitalize each word
			.join(' '); // Join words back with spaces
	}

}
